// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/web.set-interval');
require('../modules/web.set-timeout');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/modules/web.timers.js
// module id = 6480
// module chunks = 25